var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSortDescending = function SvgIconSortDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.543 3.793a1 1 0 0 1 1.414 0l3.75 3.75a1 1 0 0 1-1.414 1.414L18.25 6.914V13.5a1 1 0 1 1-2 0V6.914l-2.043 2.043a1 1 0 1 1-1.414-1.414zM3.5 6a1 1 0 0 1 1-1h5.25a1 1 0 1 1 0 2H4.5a1 1 0 0 1-1-1M3.5 12a1 1 0 0 1 1-1h6.75a1 1 0 1 1 0 2H4.5a1 1 0 0 1-1-1M3.5 18a1 1 0 0 1 1-1h12.75a1 1 0 1 1 0 2H4.5a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconSortDescending;